module.exports = __webpack_public_path__ + "img/icon-supervisor-cover.a96bcfe5.png";